import type { Dtos, FredSyncScope } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { fredSyncRunsQueryKey } from "../fred.keys";

/** A 202 means the long-running refresh was accepted; callers must watch the returned run. */
/** Snapshot caches remain valid until the run watcher observes a terminal status. */
export const useRefreshFred = () => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (scope?: FredSyncScope) =>
			await post<Dtos.MarketIntelligence.Fred.Refresh.Accepted>(
				"/v2/admin/market-intelligence/fred/refresh",
				{ scope },
			),
		onSettled: async () => {
			await queryClient.invalidateQueries({ queryKey: fredSyncRunsQueryKey() });
		},
	});
};
